/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */
/* istanbul ignore file */
import {Directive, HostListener, Output, OnDestroy, EventEmitter, Optional, Inject, Input, } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Directive({
  selector: '[appFolderPicker]',
  exportAs: 'appFolderPicker',
})
export class FolderPickerDirective implements OnDestroy {
  // tslint:disable-next-line: variable-name
  private _form: HTMLFormElement;

  // tslint:disable-next-line: variable-name
  private _nativeFileElement: any;

  @Output()
  filesChanged = new EventEmitter<FileList>();
  @Input() directoryPicker = false;

  @Output()
  filesReset = new EventEmitter();
  // tslint:disable-next-line: variable-name
  constructor(@Optional() @Inject(DOCUMENT) private _document: Document) {
    if (this._document) {
      this._form = this._document.createElement('form');
      this._nativeFileElement = this._document.createElement('input');
      this._nativeFileElement.type = 'file';
      this._nativeFileElement.multiple = true;
      this._nativeFileElement.addEventListener('change', this._onFilesChanged);
      this._form.appendChild(this.nativeFileElement);
    }
  }

  ngOnDestroy() {
    this._nativeFileElement.removeEventListener('change', this._onFilesChanged);
    this._nativeFileElement.remove();
    this._form.remove();
  }

  @HostListener('click', ['$event'])
  _onClick(event: Event) {
    event.preventDefault();
    this._nativeFileElement.webkitdirectory = this.directoryPicker === true ? true : false;
    this._nativeFileElement.click();
  }

  get files(): FileList | undefined {
    return this._nativeFileElement.files;
  }

  // tslint:disable-next-line: variable-name
  private _onFilesChanged = () => {
    this.filesChanged.emit(this._nativeFileElement.files);
  }

  get nativeFileElement() {
    return this._nativeFileElement;
  }

  get form() {
    return this._form;
  }
}
